import { Component, createRef } from "react"
import LandingSearchHeader from "../part/header_search"
import LandingFooter from "../part/landing.footer"
import FloatingContact from "../part/floating.contact"
import { HiOutlineCalendarDateRange } from "react-icons/hi2";
import { LuArrowUpRight } from "react-icons/lu";
import { LuListFilter } from "react-icons/lu";
import axios from "axios";
import { Link } from "react-router-dom";
import { LiaTrashSolid } from "react-icons/lia";
import LoadingError from "../part/loading_error";
import NetworkIssue from "../part/network";
import SimpleDateDisplay from "../part/simpleDateDisplay";
import { IoIosArrowDown } from "react-icons/io";
import { LuSearch } from "react-icons/lu";
import { FaRegSadTear } from "react-icons/fa";


class Blog extends Component {
    state = {
        blog: [],
        loading: false,
        network: false,
        filter: "All",
        error: null, // Added error to state for consistency
        user: {
            role: ""
        },
        dropdown: false,
        searchBar: "",
    }

    dropdownRef = createRef();
    /**
     * Correction: Add componentDidMount to fetch data when the component loads.
     */
    componentDidMount() {
        this.fetchBlogs();

        const storedUser = localStorage.getItem('user');

        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                this.setState({ user: user })
            } catch (error) {
                console.error("Error parsing user data:", error);
                localStorage.removeItem('user');
            }
        }

        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        // If the click is outside the dropdown container, close it
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ dropdown: false });
        }
    };

    fetchBlogs = async () => {
        this.setState({ loading: true })
        const accessToken = localStorage.getItem("accessToken");
        let headers = {};

        if (accessToken) {
            headers = {
                Authorization: `Bearer ${accessToken}`,
            };
        }

        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/blogs", {
                headers: headers,
            });
            // Ensure the response data is an array before setting state, though typically APIs return arrays here.
            this.setState({ blog: Array.isArray(response.data) ? response.data : [], loading: false });
        } catch (error) {
            console.error("Submission error:", error);
            let errorMessage = "Network error or server unavailable.";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.detail || JSON.stringify(error.response.data);
            } else if (error.code === "ERR_NETWORK") {
                this.setState({ network: true });
            }
            this.setState({ error: errorMessage });

            setTimeout(() => {
                this.setState({ error: null });
            }, 5000);

        } finally {
            this.setState({ loading: false });
        }
    }

    /**
     * Correction: The filter logic must explicitly RETURN the result of the filter operation.
     * Also, the filter condition must check 'list.label' not 'blog.label'.
     */
    // blogFilter = () => {
    //     const { blog, filter } = this.state
    //     if (filter === "" || filter === "All" || filter === "All Blog") {
    //         return blog
    //     } else {
    //         // Correctly return the filtered array
    //         return blog.filter(list => {
    //             // Correctly check the current item's label
    //             return list.label === filter
    //         })
    //     }
    // }

    handleSearchChange = (e) => {
        this.setState({ searchBar: e.target.value });
    };


    blogFilter = () => {
        const { blog, filter, searchBar } = this.state;
        let filteredList = blog;

        // First: Filter by Category (GIS, Drone, etc.)
        if (filter !== "" && filter !== "All" && filter !== "All Blog") {
            filteredList = filteredList.filter(item => item.label === filter);
        }

        // Second: Filter by Search Query (Title, Narration, Label)
        if (searchBar.trim() !== "") {
            const query = searchBar.toLowerCase();
            filteredList = filteredList.filter(item => {
                return (
                    item.title?.toLowerCase().includes(query) ||
                    item.narration?.toLowerCase().includes(query) ||
                    item.label?.toLowerCase().includes(query)
                );
            });
        }

        return filteredList;
    };

    handleFilterChange = (value) => {
        this.setState({
            filter: value
        })
        // The blogFilter is called in render(), so no need to call it here, 
        // but calling setState will trigger a re-render where blogFilter is used.
    }


    handleDelete = async (list) => {
        const accessToken = localStorage.getItem("accessToken");
        this.setState({ loading: true })
        try {
            const response = await axios.delete(`https://api.geoinfoacademy.com/api/blogs/${list}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 204 || response.status === 200) { // Check for successful delete status codes (204 No Content is common)
                console.log("Document deleted successfully:", list.id);
                this.fetchBlogs();
            } else {
                console.error("Error deleting document:", response.status, response.data);

            }
            this.setState({ loading: false })
        } catch (error) {
            console.error("Error deleting document:", error);
            alert("Error deleting document")
            this.setState({ loading: false })
        }
    };


    handleDropdown = () => {
        this.setState((prevState) => ({
            dropdown: !prevState.dropdown
        }));
    };


    handleClearFilter = () => {
        this.setState({
            searchBar: "",
            filter: "All Blog"
        })
    }


    render() {
        const { blog, loading, error, user, network, dropdown, filter } = this.state
        const filterdata = this.blogFilter() // This now correctly returns an array (filtered or full)

        // Safely get the first blog post for the "Recent Post" section
        const firstBlog = blog.length > 0 ? blog[0] : null;

        const blogList = filterdata.length > 0 ? filterdata.map(list => {
            return (
                <section className="card_blog_container" key={list.id}>
                    <div className="card_image">
                        <img src={list.image} alt={list.title} />
                    </div>
                    <div className="card_blog_content">
                        <h2>
                            <span>{list.label}</span><br />
                            {list.title}
                        </h2>
                        <p>{list.narration}</p>
                        <div className="button">
                            <Link to={`/blog/${list.id}`}><button>Read More <LuArrowUpRight /></button></Link>
                            {user.role === "tutor" ?
                                <button onClick={() => this.handleDelete(list.id)} disabled={loading}>Delete <LiaTrashSolid /></button>
                                : null}
                        </div>
                    </div>
                </section>
            )
        }) : (loading ? null :
            null
        ) // Added loading/empty state

        return (
            <div className="body">
                <LandingSearchHeader />
                <div className="blog_cover">
                    <div className="blog_container">

                        {/* Display error message if it exists */}
                        {error && <div className="error-message">{error}</div>}

                        <div className="landing_blog_cover">
                            <h2>
                                <span>Unlock Knowledge</span><br />
                                Browse Our Resources
                            </h2>
                            <p>Explore the tools and technologies transforming spatial data into powerful solutions.</p>
                        </div>

                        {/* Only render "Recent Post" if data is available (firstBlog is not null) */}
                        {firstBlog && (
                            <div className="blog_card_cover">
                                <h3>Recent Post</h3>
                                <div className="card_blog_contain">
                                    <img src={firstBlog.image} alt="main_image" />
                                    <div className="card_blog_content">

                                        <div className="card_blog_content_cover">
                                            <section className="card_blog_writeup one">
                                                <h2>
                                                    {firstBlog.title} {/* Safely using firstBlog */}
                                                </h2>
                                                <p>
                                                    {firstBlog.narration} {/* Safely using firstBlog */}
                                                </p>
                                                <div className="button">
                                                    <Link to={`/blog/${firstBlog.id}`}><button>Read More <LuArrowUpRight /></button></Link>
                                                    {user.role === "tutor" ?
                                                        <button onClick={() => this.handleDelete(firstBlog.id)} disabled={loading}>Delete <LiaTrashSolid /></button>
                                                        : null}
                                                    <HiOutlineCalendarDateRange />
                                                    {/* NOTE: Date is hardcoded here, ideally, use a date property from firstBlog */}
                                                    <p><SimpleDateDisplay dateString={firstBlog.created_at} /></p>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* <div className="filter_blog">
                            <p><LuListFilter /> Filter</p>
                            <button onClick={() => this.handleFilterChange("All")}>All</button>
                            <button onClick={() => this.handleFilterChange("GIS")}>GIS</button>
                            <button onClick={() => this.handleFilterChange("Drone")}>Drone</button>
                            <button onClick={() => this.handleFilterChange("Land Survey")}>Land Survey</button>
                            <button onClick={() => this.handleFilterChange("Event")}>Event</button>
                        </div> */}



                        <div className="filter_blog_cover">

                            <div className="filter_blog_contain">
                                <p><LuListFilter /> Filter</p>
                                <div className="filter_drop_cover" ref={this.dropdownRef}>
                                    <button onClick={this.handleDropdown}> {filter} <IoIosArrowDown /></button>
                                    {dropdown &&
                                        <div className="filter_dropdown_contain" >
                                            <li onClick={() => this.handleFilterChange("All Blog")}>All Blog</li>
                                            <li onClick={() => this.handleFilterChange("GIS")}>GIS</li>
                                            <li onClick={() => this.handleFilterChange("Drone")}>Drone</li>
                                            <li onClick={() => this.handleFilterChange("Land Survey")}>Land Survey</li>
                                            <li onClick={() => this.handleFilterChange("Event")}>Event</li>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="filter_blog_contain">
                                <div className="filter_blog_search">
                                    <input type="text" placeholder="search blog" value={this.state.searchBar} onChange={this.handleSearchChange} />
                                    <button className="search"><LuSearch /> Search</button>
                                </div>
                            </div>

                        </div>



                        {filterdata.length > 0 ?
                            <div className="blog_list_card">
                                {blogList}
                            </div>
                            :
                            <div className="enroll_error" style={{ width: "100%" }}>
                                <div className="enroll_cover">
                                    <FaRegSadTear />
                                    <p>No Blog Found, Clear Filter And Try Again  </p>
                                    <button onClick={this.handleClearFilter}> Clear Filter</button>
                                </div>
                            </div>}

                    </div>
                </div>

                <FloatingContact />
                <LandingFooter />

                {loading ? <LoadingError /> : null}
                {network ? <NetworkIssue /> : null}
            </div>
        )
    }
}

export default Blog



// import { Component } from "react"
// import LandingSearchHeader from "../part/header_search"
// import LandingFooter from "../part/landing.footer"
// import FloatingContact from "../part/floating.contact"
// import { HiOutlineCalendarDateRange } from "react-icons/hi2";
// import { LuArrowUpRight } from "react-icons/lu";
// import { LuListFilter } from "react-icons/lu";
// import axios from "axios";
// import { Link } from "react-router-dom";



// class Blog extends Component {
//     state = {
//         blog: [],
//         loading: false,
//         filter: "All"
//     }

//     fetchBlogs = async () => {
//         this.setState({ loading: true })
//         const accessToken = localStorage.getItem("accessToken");
//         let headers = {}; // Initialize an empty headers object

//         if (accessToken) {
//             headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };
//         }

//         try {
//             const response = await axios.get("https://api.geoinfoacademy.com/api/blogs/", {
//                 headers: headers,
//             });
//             this.setState({ blog: response.data, loading: false });
//         } catch (error) {
//             console.error("Submission error:", error);
//             let errorMessage = "Network error or server unavailable.";
//             if (error.response && error.response.data) {
//                 errorMessage = error.response.data.detail || JSON.stringify(error.response.data);
//             }
//             this.setState({ error: errorMessage });

//             setTimeout(() => {
//                 this.setState({ error: null });
//             }, 5000);

//         } finally {
//             this.setState({ loading: false });
//         }
//     }



//     blogFilter = () =>{
//         const { blog , filter} = this.state
//         if(filter === "" || filter === "All"){
//             return blog
//         }else{
//             blog.filter(list =>{
//                 return blog.label === filter
//             })
//         }
//     }

//     handleFilterChange = (value) =>{
//         this.setState({
//             filter : value
//         })
//         this.blogFilter()
//     }


//     render() {
//         const { blog } = this.state
//         const filterdata = this.blogFilter()

//         const blogList = filterdata.length > 0 ? filterdata.map(list => {
//             return (
//                 <section className="card_blog_container" key={list.id}>
//                     <div className="card_image">
//                         <img src={list.image} alt={list.title} />
//                     </div>
//                     <div className="card_blog_content">
//                         <h2>
//                             <span>{list.label}</span><br />
//                             {list.title}
//                         </h2>
//                         <p>{list.narration}</p>
//                         <div className="button">
//                             <Link to={`/blog/${list.id}`}><button>Read More <LuArrowUpRight /></button></Link>
//                         </div>
//                     </div>
//                 </section>
//             )
//         }) : null


//         return (
//             <div className="body">
//                 <LandingSearchHeader />
//                 <div className="blog_cover">
//                     <div className="blog_container">


//                         <div className="landing_blog_cover">
//                             <h2>
//                                 <span>Unlock Knowledge</span><br />
//                                 Browse Our Resources
//                             </h2>
//                             <p>Explore the tools and technologies transforming spatial data into powerful solutions.</p>
//                         </div>


//                         <div className="blog_card_cover">
//                             <h3>Recent Post</h3>
//                             <div className="card_blog_contain">


//                                 <div className="card_blog_content">
//                                     <div className="card_blog_content_cover">
//                                         <section className="card_blog_writeup one">
//                                             <h2>
//                                                 {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. */}
//                                                 {blog[0].title}
//                                             </h2>
//                                             <p>
//                                                 {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente explicabo eaque ducimus amet similique, repudiandae maxime et sit ad vitae. */}
//                                                 {blog[0].narration}
//                                             </p>
//                                             <div className="button">
//                                                 <Link to={`/blog/${blog[0].id}`}><button>Read More <LuArrowUpRight /></button></Link>
//                                                 <HiOutlineCalendarDateRange />
//                                                 <p>17 Nov 2025</p>
//                                             </div>
//                                         </section>
//                                         {/* <section className="card_blog_writeup two">
//                                             <LuArrowUpRight />
//                                             <div className="button">
//                                                 <button>Click me </button>
//                                             </div>

//                                         </section>*/}
//                                     </div>
//                                 </div>

//                             </div>
//                         </div>



//                         <div className="filter_blog">
//                             <p><LuListFilter /> Filter</p>
//                             <button onClick={() => this.handleFilterChange("All")}>All</button>
//                             <button onClick={() => this.handleFilterChange("GIS")}>GIS</button>
//                             <button onClick={() => this.handleFilterChange("Drone")}>Drone</button>
//                             <button onClick={() => this.handleFilterChange("Land Survey")}>Land Survey</button>
//                             <button onClick={() => this.handleFilterChange("Event")}>Event</button>
//                         </div>




//                         <div className="blog_list_card">
//                             {blogList}


//                             {/* <section className="card_blog_container">
//                                 <div className="card_image"></div>
//                                 <div className="card_blog_content">
//                                     <h2>
//                                         <span>Lorem ipsum </span><br />
//                                         Lorem ipsum dolor sit amet consectetur adipisicing elit.
//                                     </h2>
//                                     <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente explicabo eaque ducimus amet similique, repudiandae maxime et sit ad vitae.</p>
//                                     <div className="button">
//                                         <button>Read More <LuArrowUpRight /></button>
//                                     </div>
//                                 </div>
//                             </section>
//                             <section className="card_blog_container">
//                                 <div className="card_image"></div>
//                                 <div className="card_blog_content">
//                                     <h2>
//                                         <span>Lorem ipsum </span><br />
//                                         Lorem ipsum dolor sit amet consectetur adipisicing elit.
//                                     </h2>
//                                     <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente explicabo eaque ducimus amet similique, repudiandae maxime et sit ad vitae.</p>
//                                     <div className="button">
//                                         <button>Read More <LuArrowUpRight /></button>
//                                     </div>
//                                 </div>
//                             </section>
//                             <section className="card_blog_container">
//                                 <div className="card_image"></div>
//                                 <div className="card_blog_content">
//                                     <h2>
//                                         <span>Lorem ipsum </span><br />
//                                         Lorem ipsum dolor sit amet consectetur adipisicing elit.
//                                     </h2>
//                                     <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente explicabo eaque ducimus amet similique, repudiandae maxime et sit ad vitae.</p>
//                                     <div className="button">
//                                         <button>Read More <LuArrowUpRight /></button>
//                                     </div>
//                                 </div>
//                             </section>
//                             <section className="card_blog_container">
//                                 <div className="card_image"></div>
//                                 <div className="card_blog_content">
//                                     <h2>
//                                         <span>Lorem ipsum </span><br />
//                                         Lorem ipsum dolor sit amet consectetur adipisicing elit.
//                                     </h2>
//                                     <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente explicabo eaque ducimus amet similique, repudiandae maxime et sit ad vitae.</p>
//                                     <div className="button">
//                                         <button>Read More <LuArrowUpRight /></button>
//                                     </div>
//                                 </div>
//                             </section>
//                             <section className="card_blog_container">
//                                 <div className="card_image"></div>
//                                 <div className="card_blog_content">
//                                     <h2>
//                                         <span>Lorem ipsum </span><br />
//                                         Lorem ipsum dolor sit amet consectetur adipisicing elit.
//                                     </h2>
//                                     <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente explicabo eaque ducimus amet similique, repudiandae maxime et sit ad vitae.</p>
//                                     <div className="button">
//                                         <button>Read More <LuArrowUpRight /></button>
//                                     </div>
//                                 </div>
//                             </section>
//                             <section className="card_blog_container">
//                                 <div className="card_image"></div>
//                                 <div className="card_blog_content">
//                                     <h2>
//                                         <span>Lorem ipsum </span><br />
//                                         Lorem ipsum dolor sit amet consectetur adipisicing elit.
//                                     </h2>
//                                     <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente explicabo eaque ducimus amet similique, repudiandae maxime et sit ad vitae.</p>
//                                     <div className="button">
//                                         <button>Read More <LuArrowUpRight /></button>
//                                     </div>
//                                 </div>
//                             </section>
//                             <section className="card_blog_container">
//                                 <div className="card_image"></div>
//                                 <div className="card_blog_content">
//                                     <h2>
//                                         <span>Lorem ipsum </span><br />
//                                         Lorem ipsum dolor sit amet consectetur adipisicing elit.
//                                     </h2>
//                                     <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente explicabo eaque ducimus amet similique, repudiandae maxime et sit ad vitae.</p>
//                                     <div className="button">
//                                         <button>Read More <LuArrowUpRight /></button>
//                                     </div>
//                                 </div>
//                             </section> */}


//                         </div>


//                     </div>
//                 </div>


//                 <FloatingContact />
//                 <LandingFooter />
//             </div>
//         )
//     }
// }



// export default Blog 